import { useRef, useState } from "react";
import {
  Flex,
  Box,
  Button as ChakraButton,
  useColorModeValue
} from "@chakra-ui/react";
import { Translation, useTranslation } from "react-i18next";
import { H2 } from "src/atoms/typography";
import CloseButton from "src/atoms/CloseButton";
import BackButton from "src/components/BackButton";
import IconAsButton from "./IconAsButton";

export default function NavigationBar({
  headingKey,
  onClose,
  onBack,
  actionButton = {},
  actionIcon,
  customIcon,
  ...rest
}) {
  const { t } = useTranslation();
  const borderColor = useColorModeValue("black12", "white8");
  const actionButtonRef = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { labelKey: actionButtonLabelKey, Menu, ...button } = actionButton;
  if (Menu) button.onClick = () => setIsMenuOpen(true);

  const Button = (
    <ChakraButton
      variant="containedPrimary"
      borderRadius="12px"
      py="5px"
      px="18px"
      minWidth="80px"
      ref={actionButtonRef}
      mr="16px"
      {...button}
    >
      {t(actionButtonLabelKey)}
    </ChakraButton>
  );

  return (
    <Translation>
      {(t) => (
        <Flex
          p="16px 24px"
          bg="transparent"
          width="100%"
          position="relative"
          borderBottom="1px solid"
          borderColor={borderColor}
          zIndex={80}
          {...rest}
        >
          <Flex alignItems="center">
            {onBack && <BackButton mr="16px" onClick={onBack} />}
            {headingKey && <H2 color="highEmphasis">{t(headingKey)}</H2>}
          </Flex>
          <Flex alignItems="center" ml="auto">
            {Boolean(actionButtonLabelKey && !Menu) && Button}
            {Menu && actionButtonLabelKey && (
              <Menu
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
                anchorEl={Button}
              />
            )}
            {customIcon && (
              <Box ml={actionButtonLabelKey ? "12px" : "0px"} mr="24px">
                {customIcon}
              </Box>
            )}
            {actionIcon && (
              <IconAsButton
                ml={actionButtonLabelKey ? "12px" : "0px"}
                mr="24px"
                icon={actionIcon.icon}
                onClick={actionIcon.onClick}
                fill="mediumEmphasis"
                size="20px"
              />
            )}
            {!onBack && onClose && <CloseButton onClick={onClose} />}
          </Flex>
        </Flex>
      )}
    </Translation>
  );
}
